import React from "react"
import { Link } from "react-router-dom"
import { Input, Button, Table, Space, message } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable } from '../../tool/axios'
import { SelectSingleProjectTypes } from "../../component/common/Selects"
import BreadCrumb from '../../component/BreadCrumb'
import getPermission from '../../js/permission'

const { Column } = Table

interface State {
    data: object[],
    loading: boolean,

    pagination: {
        current: number,
        pageSize: number,
        total: number,
        showSizeChanger: boolean
    },

    fetchOtherParams: {
        item_type_id: string | undefined,
        item_name: string | undefined
    },

    formParams: {
        item_type: string | null
    },

    offShelfVisible: boolean,
    addVisible: boolean,
    detailModalVisible: boolean,

    modalProps: {
        isModalVisible: boolean,
        modalTitle: string,
        previewVisible: boolean,
        previewImage: string,
        previewTitle: string
        treeDatavalue: string
    },

    permissionList: string[]
}

export default class CkSingleList extends React.Component {
    state: State = {
        data: [],
        loading: false,
        pagination: {
            current: 1,
            pageSize: 8,
            total: 0,
            showSizeChanger: false
        },

        fetchOtherParams: {
            item_type_id: undefined,
            item_name: undefined
        },

        formParams: {
            item_type: null
        },

        modalProps: {
            isModalVisible: false,
            modalTitle: '',
            // 上传图片数据
            previewVisible: false,
            previewImage: '',
            previewTitle: '',
            treeDatavalue: ''
        },

        offShelfVisible: false,
        addVisible: false,
        detailModalVisible: false,
        permissionList: []
    }

    componentDidMount() {
        this.setState({
            permissionList: getPermission()
        })

        const { pagination, fetchOtherParams } = this.state
        this.fetch({ pagination, fetchOtherParams })
    }

    handleInputChange(value: string, attr: string) {
        let { fetchOtherParams }: { fetchOtherParams: any } = this.state
        fetchOtherParams[attr] = value

        this.setState({ fetchOtherParams })
    }

    handleSearch() {
        let { pagination, fetchOtherParams } = this.state
        pagination.current = 1

        this.setState({ pagination }, () => {
            this.fetch({ pagination, fetchOtherParams })
        })
    }

    handleTableChange = (antPagination: any) => {
        const { fetchOtherParams, pagination } = this.state
        pagination.current = antPagination.current

        this.fetch({
            pagination,
            fetchOtherParams
        })
    }

    fetch({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) {
        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        axiosTable.get('/chankang_center/item_single/page_list', {
            params: {
                ...iPagination,
                ...fetchOtherParams
            }

        }).then((response: any) => {
            if (response) {
                const { pagination } = this.state
                pagination.total = response.total
                pagination.pageSize = response.size
                pagination.current = response.current

                this.setState({
                    pagination,
                    data: response.records
                })
            }
        })
    }

    resetForm() {
        let { pagination, fetchOtherParams } = this.state
        pagination.current = 1

        fetchOtherParams.item_type_id = undefined
        fetchOtherParams.item_name = undefined

        this.setState({
            pagination,
            fetchOtherParams
        })

        this.fetch({ pagination, fetchOtherParams })
    }

    showDetail() {
        this.setState({ detailModalVisible: true })
    }

    offShelf() {
        this.setState({ offShelfVisible: true })
    }

    render() {
        let { item_type_id, item_name } = this.state.fetchOtherParams
        let permissionList = this.state.permissionList

        return (<div className="common-page">
            {/* 产康中心 -> 产康项目管理 -> 产康单项管理 */}
            <BreadCrumb position={['产康中心', '产康单项管理']} />

            <div className="common-top-form">
                <Space direction="horizontal" wrap>
                    <div style={{ marginRight: 8, marginBottom: 12 }}>
                        <SelectSingleProjectTypes value={item_type_id} onChange={(value: string) => {
                            let { fetchOtherParams } = this.state
                            fetchOtherParams.item_type_id = value

                            this.setState({ fetchOtherParams })
                        }} />
                    </div>
                    <Input style={{ marginRight: 8, marginBottom: 12, width: '150px' }} placeholder="项目名称" onChange={(e: { target: { value: string } }) => { this.handleInputChange(e.target.value, 'item_name') }} value={item_name} />
                </Space>

                <div style={{ marginTop: 10 }}>
                    {permissionList.includes('查询') && <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn" icon={<SearchOutlined />} onClick={this.handleSearch.bind(this)} >查询</Button>}
                    <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={this.resetForm.bind(this)} icon={<RedoOutlined />}>重置</Button>
                    {permissionList.includes('添加') && <Button style={{ marginRight: 12, marginBottom: 12 }} type="primary"><Link to="/ck_single_list_add">添加</Link></Button>}
                </div>
            </div>

            <div className="common-main">
                <Table dataSource={this.state.data} scroll={{ x: 'max-content' }} bordered={true} rowKey="item_id" pagination={this.state.pagination} onChange={this.handleTableChange}>
                    <Column title="项目名称" dataIndex="item_name" key="item_name" />
                    <Column title="项目分类" dataIndex="item_type_name" key="item_type_name" />
                    <Column title="项目来源" dataIndex="item_in_out_desc" key="item_in_out_desc" />
                    <Column title="项目合作商" dataIndex="item_coperation_name" key="item_coperation_name" />
                    <Column title="服务时长" dataIndex="service_time" key="service_time" />
                    <Column title="参考价格" dataIndex="suggest_price" key="suggest_price" />
                    <Column title="创建时间" dataIndex="create_time" key="create_time" />

                    <Column
                        title="操作"
                        key="action"
                        render={(text, record: any) => (
                            <Space size="middle">
                                {permissionList.includes('编辑') && <Space size="middle">
                                    {record.item_status == 1 ?
                                        <Button type="link" onClick={() => { message.error(`请先下架${record.item_name}再进行编辑!`, 5) }}>编辑</Button> :
                                        <Button type="link"><Link to={"/ck_single_list_edit/" + record.item_id}>编辑</Link></Button>}
                                </Space>}
                            </Space>
                        )}
                    />
                </Table>
            </div>
        </div>)
    }
}